(function(){
  var VERSION = '2026-07-14-inventory-aware-v2';

  if(window.HPRPackageBuilder && window.HPRPackageBuilder.version === VERSION && typeof window.HPRPackageBuilder.initAll === 'function') {
    window.HPRPackageBuilder.initAll(document);
    return;
  }

  function money(cents){
    cents = parseInt(cents || 0, 10);
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function text(value){ return value || ''; }

  function route(name, fallback){
    if(window.routes && window.routes[name]) return window.routes[name];
    return fallback;
  }

  function withJs(url){
    if(!url) return '';
    return url.indexOf('.js') > -1 ? url : url + '.js';
  }

  function parseJSONText(raw){
    if(!raw) return null;
    var trimmed = raw.trim();
    if(!(trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[')) return null;
    try { return JSON.parse(trimmed); } catch(e) { return null; }
  }

  function requestJSON(url, options){
    options = options || {};
    options.credentials = options.credentials || 'same-origin';
    options.headers = options.headers || {};
    if(!options.headers['Accept']) options.headers['Accept'] = 'application/json';
    if(!options.headers['X-Requested-With']) options.headers['X-Requested-With'] = 'XMLHttpRequest';

    return fetch(url, options).then(function(response){
      var contentType = response.headers.get('content-type') || '';
      return response.text().then(function(raw){
        var data = null;
        if(contentType.indexOf('application/json') > -1){
          try { data = raw ? JSON.parse(raw) : {}; } catch(e) { data = null; }
        } else {
          data = parseJSONText(raw);
        }

        if(!response.ok){
          var msg = (data && (data.description || data.message || data.error)) || 'Shopify rejected this cart request.';
          var err = new Error(msg);
          err.status = response.status;
          err.data = data;
          err.raw = raw;
          throw err;
        }

        if(!data){
          var nonJson = new Error('Shopify returned a page instead of cart data. Refresh the page and try again. If it repeats, check the selected wheel/tyre is published, available in the current Market, and in stock at a fulfilment location.');
          nonJson.status = response.status;
          nonJson.raw = raw;
          nonJson.nonJson = true;
          throw nonJson;
        }
        return data;
      });
    });
  }

  function initBuilder(builder){
    if(!builder || builder.getAttribute('data-hpr-initialized') === VERSION) return;
    builder.setAttribute('data-hpr-initialized', VERSION);

    var productJsonEl = builder.querySelector('[data-hpr-product-json]');
    if(!productJsonEl) return;

    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch(e) { return; }

    var wheelQty = parseInt(builder.getAttribute('data-wheel-qty') || '4', 10);
    if(!wheelQty || wheelQty < 1) wheelQty = 4;

    var modeButtons = builder.querySelectorAll('[data-package-mode]');
    var panels = builder.querySelectorAll('[data-panel]');
    var messageEl = builder.querySelector('[data-package-message]');
    var totalEl = builder.querySelector('[data-package-total]');
    var compareWrap = builder.querySelector('[data-package-compare-wrap]');
    var compareEl = builder.querySelector('[data-package-compare]');
    var savingWrap = builder.querySelector('[data-package-saving-wrap]');
    var savingEl = builder.querySelector('[data-package-saving]');
    var wheelVariantLabel = builder.querySelector('[data-wheel-variant-label]');
    var wheelPriceEl = builder.querySelector('[data-wheel-price]');
    var wheelStockEl = builder.querySelector('[data-wheel-stock]');
    var wheelImageEl = builder.querySelector('[data-wheel-image]');
    var addPackageBtn = builder.querySelector('[data-add-package]');
    var tyresList = builder.querySelector('[data-tyres-list]');
    var drawer = builder.querySelector('[data-tyre-drawer]');
    var drawerList = builder.querySelector('[data-tyre-drawer-list]');
    var openDrawerBtn = builder.querySelector('[data-open-tyre-drawer]');
    var closeDrawerBtns = builder.querySelectorAll('[data-close-tyre-drawer]');
    var defaultPanelTemplate = builder.querySelector('[data-default-tyres-panel-template]');
    var defaultDrawerTemplate = builder.querySelector('[data-default-tyres-drawer-template]') || defaultPanelTemplate;
    var wheelTotalEl = builder.querySelector('[data-wheel-total]');
    var isAdding = false;
    var selectedTyreId = null;

    var productForm = builder.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var wheelSelect = productForm ? productForm.querySelector('[name="id"]') : document.querySelector('[name="id"]');

    function setMessage(msg, type){
      if(!messageEl) return;
      messageEl.textContent = msg || '';
      messageEl.className = 'hpr-package-builder__message' + (type ? ' is-' + type : '');
    }

    function getWheelVariant(){
      var variantId = wheelSelect ? parseInt(wheelSelect.value, 10) : null;
      return product.variants.find(function(v){ return v.id === variantId; }) || product.variants[0];
    }

    function getWheelInventory(wheel){
      var option = wheelSelect && wheelSelect.selectedIndex >= 0 ? wheelSelect.options[wheelSelect.selectedIndex] : null;
      var management = option ? (option.getAttribute('data-inventory_management') || '') : (wheel.inventory_management || '');
      var policy = option ? (option.getAttribute('data-inventory_policy') || '') : (wheel.inventory_policy || '');
      var quantity = option ? parseInt(option.getAttribute('data-inventory_quantity') || '0', 10) : parseInt(wheel.inventory_quantity || '0', 10);
      if(isNaN(quantity) || quantity < 0) quantity = 0;
      return {
        quantity: quantity,
        limited: !!management && management !== 'null' && policy === 'deny'
      };
    }

    function tyreDataFromInput(input){
      if(!input) return null;
      return {
        id: parseInt(input.value, 10),
        title: text(input.getAttribute('data-tyre-title')),
        variantTitle: text(input.getAttribute('data-tyre-variant-title')),
        url: text(input.getAttribute('data-tyre-url')),
        price: parseInt(input.getAttribute('data-tyre-price') || '0', 10),
        compareAt: parseInt(input.getAttribute('data-tyre-compare-at') || '0', 10),
        available: input.getAttribute('data-tyre-available') === 'true',
        policy: input.getAttribute('data-tyre-policy') || 'deny'
      };
    }

    function findTyreInputById(id){
      if(!id) return null;
      var inputs = builder.querySelectorAll('[data-tyre-option]:not(:disabled)');
      for(var i = 0; i < inputs.length; i++){
        if(inputs[i].value === String(id)) return inputs[i];
      }
      return null;
    }

    function syncTyreInputs(id){
      selectedTyreId = id ? String(id) : null;
      builder.querySelectorAll('[data-tyre-option]').forEach(function(input){
        input.checked = !!selectedTyreId && !input.disabled && input.value === selectedTyreId;
      });
    }

    function getSelectedTyre(){
      var checked = selectedTyreId ? findTyreInputById(selectedTyreId) : null;
      if(!checked) checked = builder.querySelector('[data-tyre-option]:checked:not(:disabled)');
      if(!checked) return null;
      selectedTyreId = checked.value;
      return tyreDataFromInput(checked);
    }

    function updateActiveCard(){
      var selected = getSelectedTyre();
      builder.querySelectorAll('[data-tyre-card]').forEach(function(card){ card.classList.remove('is-selected'); });
      if(!selected) return;
      builder.querySelectorAll('[data-tyre-option]').forEach(function(input){
        if(input.value === String(selected.id)){
          var card = input.closest('[data-tyre-card]');
          if(card) card.classList.add('is-selected');
        }
      });
    }

    function promoteTyreToPanel(input){
      if(!input || !tyresList) return;
      if(tyresList.querySelector('[data-tyre-option][value="' + input.value + '"]')) return;
      var sourceCard = input.closest('[data-tyre-card]');
      if(!sourceCard) return;
      var clone = sourceCard.cloneNode(true);
      var cloneInput = clone.querySelector('[data-tyre-option]');
      if(cloneInput){
        var firstPanelInput = tyresList.querySelector('[data-tyre-option]');
        cloneInput.name = firstPanelInput ? firstPanelInput.name : 'hpr-tyre-select-panel';
        cloneInput.removeAttribute('data-hpr-bound');
        cloneInput.checked = true;
      }
      clone.classList.add('is-selected');
      var cards = tyresList.querySelectorAll('[data-tyre-card]');
      if(cards.length >= 3) tyresList.replaceChild(clone, cards[cards.length - 1]);
      else tyresList.appendChild(clone);
      bindTyreOptions(tyresList);
    }

    function bindTyreOptions(scope){
      scope = scope || builder;
      scope.querySelectorAll('[data-tyre-option]').forEach(function(opt){
        if(opt.getAttribute('data-hpr-bound') === VERSION) return;
        opt.setAttribute('data-hpr-bound', VERSION);
        opt.addEventListener('change', function(){
          if(opt.disabled) return;
          syncTyreInputs(opt.value);
          if(drawerList && drawerList.contains(opt)) promoteTyreToPanel(opt);
          updateActiveCard();
          updateSummary();
          setMessage('', '');
        });
      });
    }

    function ensureFirstSellableSelected(){
      var existing = selectedTyreId ? findTyreInputById(selectedTyreId) : null;
      if(existing){
        syncTyreInputs(existing.value);
        return;
      }
      var selected = builder.querySelector('[data-tyre-option]:checked:not(:disabled)');
      if(selected){
        syncTyreInputs(selected.value);
        return;
      }
      var first = builder.querySelector('[data-tyre-option]:not(:disabled)');
      if(first) syncTyreInputs(first.value);
    }

    function renderTyresForVariant(variantId, options){
      options = options || {};
      var panelTemplate = builder.querySelector('[data-variant-tyres-panel-template="' + variantId + '"]') || defaultPanelTemplate;
      var drawerTemplate = builder.querySelector('[data-variant-tyres-drawer-template="' + variantId + '"]') || defaultDrawerTemplate || panelTemplate;

      if(options.panel !== false && tyresList && panelTemplate){
        selectedTyreId = null;
        tyresList.innerHTML = panelTemplate.innerHTML;
        bindTyreOptions(tyresList);
        if(drawerList && !options.drawer){
          drawerList.innerHTML = '<div class="hpr-package-builder__drawer-placeholder">Choose “Browse more tyre options” to load tyre options.</div>';
        }
      }
      if(options.drawer && drawerList && drawerTemplate){
        drawerList.innerHTML = drawerTemplate.innerHTML;
        bindTyreOptions(drawerList);
      }
      ensureFirstSellableSelected();
      updateActiveCard();
      updateSummary();
    }

    function updateSummary(){
      var wheel = getWheelVariant();
      var tyre = getSelectedTyre();
      if(!wheel) return;

      if(wheelVariantLabel) wheelVariantLabel.textContent = wheel.title || '';
      if(wheelPriceEl) wheelPriceEl.textContent = money(wheel.price);
      var wheelInventory = getWheelInventory(wheel);
      var enoughWheelStock = !wheelInventory.limited || wheelInventory.quantity >= wheelQty;
      if(wheelStockEl){
        var ok = !!wheel.available;
        wheelStockEl.textContent = ok && wheelInventory.limited && wheelInventory.quantity <= 20 ? 'Only ' + wheelInventory.quantity + ' in stock' : (ok ? 'In stock' : 'Sold out');
        wheelStockEl.style.backgroundColor = ok && enoughWheelStock ? 'rgba(22, 163, 74, 0.12)' : 'rgba(220, 38, 38, 0.12)';
        wheelStockEl.style.color = ok && enoughWheelStock ? '#15803d' : '#b91c1c';
      }
      if(wheelImageEl){
        var src = '';
        if(wheel.featured_media && wheel.featured_media.preview_image && wheel.featured_media.preview_image.src) src = wheel.featured_media.preview_image.src;
        else if(wheel.featured_image && wheel.featured_image.src) src = wheel.featured_image.src;
        if(src) wheelImageEl.src = src;
      }

      var wheelTotal = parseInt(wheel.price || 0, 10) * wheelQty;
      if(wheelTotalEl) wheelTotalEl.textContent = money(wheelTotal);
      var total = wheelTotal;
      var compareTotal = parseInt(wheel.compare_at_price || 0, 10) * wheelQty;
      if(tyre){
        total += tyre.price * wheelQty;
        compareTotal += (tyre.compareAt || 0) * wheelQty;
      }
      if(totalEl) totalEl.textContent = money(total);

      if(compareWrap && compareEl && savingWrap && savingEl){
        if(compareTotal > total){
          compareWrap.hidden = false;
          savingWrap.hidden = false;
          compareEl.textContent = money(compareTotal);
          savingEl.textContent = money(compareTotal - total);
        } else {
          compareWrap.hidden = true;
          savingWrap.hidden = true;
          compareEl.textContent = '';
          savingEl.textContent = '';
        }
      }

      if(addPackageBtn){
        var tyreSellable = !!tyre && (tyre.available || tyre.policy === 'continue');
        var disabled = isAdding || !wheel.available || !enoughWheelStock || !tyreSellable;
        addPackageBtn.disabled = disabled;
        addPackageBtn.classList.toggle('disabled', disabled);
        if(wheel.available && !enoughWheelStock){
          addPackageBtn.setAttribute('title', 'Only ' + wheelInventory.quantity + ' wheel(s) are in stock; this package requires ' + wheelQty + '.');
        } else {
          addPackageBtn.removeAttribute('title');
        }
      }
    }

    function setMode(mode){
      modeButtons.forEach(function(btn){
        var active = btn.getAttribute('data-package-mode') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function(panel){ panel.classList.toggle('is-active', panel.getAttribute('data-panel') === mode); });
    }

    function openDrawer(){
      if(!drawer || !drawerList) return;
      var wheel = getWheelVariant();
      if(wheel) renderTyresForVariant(wheel.id, {panel:false, drawer:true});
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hpr-tyre-drawer-open');
    }

    function closeDrawer(){
      if(!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hpr-tyre-drawer-open');
      updateActiveCard();
    }

    function updateCartIndicators(cart){
      if(!cart) return;
      document.querySelectorAll('.header_cart_count, [data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
      var total = document.querySelector('.cart_total_price');
      if(total) total.textContent = money(cart.total_price);
    }

    function openThemeCartDrawer(){
      try {
        if(window.theme && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function' && document.querySelector('#sidebar-cart')){
          theme.Cart.prototype._onProductAdded();
        }
      } catch(e) {}
    }

    function addPackage(){
      if(isAdding) return;
      var wheel = getWheelVariant();
      var tyre = getSelectedTyre();
      if(!wheel || !tyre){ setMessage('Please choose an available tyre option first.', 'error'); return; }
      if(!wheel.available){ setMessage('The selected wheel variant is not available.', 'error'); return; }
      var wheelInventory = getWheelInventory(wheel);
      if(wheelInventory.limited && wheelInventory.quantity < wheelQty){
        setMessage('Only ' + wheelInventory.quantity + ' wheel(s) are in stock. This package requires ' + wheelQty + '.', 'error');
        return;
      }
      if(!(tyre.available || tyre.policy === 'continue')){ setMessage('The selected tyre is not available.', 'error'); return; }

      isAdding = true;
      if(addPackageBtn){
        addPackageBtn.disabled = true;
        addPackageBtn.setAttribute('aria-busy', 'true');
      }
      setMessage('Adding package to cart...', '');

      var packageId = 'HPR-' + Date.now();
      var wheelTitle = product.title + (wheel.title && wheel.title !== 'Default Title' ? ' - ' + wheel.title : '');
      var tyreTitle = tyre.title + (tyre.variantTitle && tyre.variantTitle !== 'Default Title' ? ' - ' + tyre.variantTitle : '');
      var items = [
        {id: wheel.id, quantity: wheelQty, properties:{'Package':'Wheel & Tyre Package','Selected wheel':wheelTitle,'Selected tyre':tyreTitle,'_hpr_package_id':packageId,'_hpr_package_role':'wheel'}},
        {id: tyre.id, quantity: wheelQty, properties:{'Package':'Wheel & Tyre Package','Selected wheel':wheelTitle,'Selected tyre':tyreTitle,'_hpr_package_id':packageId,'_hpr_package_role':'tyre'}}
      ];

      var addUrl = withJs(route('cartAddUrl', '/cart/add'));
      var cartUrl = withJs(route('cartUrl', '/cart'));

      requestJSON(addUrl, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({items: items})
      }).catch(function(error){
        if(!error.nonJson) throw error;
        // Fallback for environments that do not accept multi-item JSON add requests.
        return requestJSON(addUrl, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify(items[0])
        }).then(function(){
          return requestJSON(addUrl, {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            body: JSON.stringify(items[1])
          });
        });
      }).then(function(){
        return requestJSON(cartUrl, {method:'GET'});
      }).then(function(cart){
        updateCartIndicators(cart);
        setMessage('Package added to cart successfully.', 'success');
        openThemeCartDrawer();
      }).catch(function(error){
        setMessage(error && error.message ? error.message : 'Something went wrong while adding the package.', 'error');
      }).finally(function(){
        isAdding = false;
        if(addPackageBtn){
          addPackageBtn.removeAttribute('aria-busy');
        }
        updateSummary();
      });
    }

    modeButtons.forEach(function(btn){
      btn.addEventListener('click', function(){ setMode(btn.getAttribute('data-package-mode')); });
    });
    if(openDrawerBtn) openDrawerBtn.addEventListener('click', openDrawer);
    closeDrawerBtns.forEach(function(btn){ btn.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(evt){ if(evt.key === 'Escape') closeDrawer(); });

    var variantDebounce;
    document.addEventListener('variantChange', function(evt){
      if(!builder.isConnected) return;
      clearTimeout(variantDebounce);
      variantDebounce = setTimeout(function(){
        var variant = evt.detail && evt.detail.variant ? evt.detail.variant : getWheelVariant();
        if(variant) renderTyresForVariant(variant.id, {panel:true, drawer:false});
        updateSummary();
      }, 30);
    });

    if(wheelSelect){
      wheelSelect.addEventListener('change', function(){
        var wheel = getWheelVariant();
        if(wheel) renderTyresForVariant(wheel.id, {panel:true, drawer:false});
        updateSummary();
      });
    }

    if(addPackageBtn) addPackageBtn.addEventListener('click', addPackage);

    bindTyreOptions(builder);
    ensureFirstSellableSelected();
    updateActiveCard();
    updateSummary();
  }

  function initAll(root){
    root = root || document;
    root.querySelectorAll('[data-hpr-package-builder]').forEach(initBuilder);
  }

  window.HPRPackageBuilder = window.HPRPackageBuilder || {};
  window.HPRPackageBuilder.version = VERSION;
  window.HPRPackageBuilder.initAll = initAll;

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(evt){ initAll(evt.target || document); });
  document.addEventListener('shopify:block:select', function(evt){ initAll(evt.target || document); });
})();
